<script setup>
import { computed } from 'vue';
import { useStore, useStoreGetters } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';
import { useEmitter } from 'dashboard/composables/emitter';
import { getUnixTime, add } from 'date-fns';
import { CMD_MUTE_CONVERSATION } from 'dashboard/helper/commandbar/events';
import wootConstants from 'dashboard/constants/globals';

const MUTE_OPTIONS = wootConstants.MUTE_OPTIONS;

const store = useStore();
const getters = useStoreGetters();
const { t } = useI18n();

const selectedChat = computed(() => getters.getSelectedChat.value);
const contextMenuChatId = computed(() => getters.getContextMenuChatId.value);

const getMutedUntilTimestamp = muteType => {
  const now = new Date();
  if (muteType === MUTE_OPTIONS.EIGHT_HOURS) {
    return getUnixTime(add(now, { hours: 8 }));
  }
  if (muteType === MUTE_OPTIONS.TWENTY_FOUR_HOURS) {
    return getUnixTime(add(now, { hours: 24 }));
  }
  if (muteType === MUTE_OPTIONS.UNTIL_RESOLVED) {
    return 'until_resolved';
  }
  return null; // forever
};

const onCmdMuteConversation = muteType => {
  const conversationId = selectedChat.value?.id || contextMenuChatId.value;
  const mutedUntil = getMutedUntilTimestamp(muteType);
  store.dispatch('muteConversation', { conversationId, mutedUntil });
  store.dispatch('setContextMenuChatId', null);
  useAlert(t('CONVERSATION.RESOLVE_DROPDOWN.MUTE_SUCCESS'));
};

useEmitter(CMD_MUTE_CONVERSATION, onCmdMuteConversation);
</script>

<template>
  <div />
</template>
